<template>
  <b-card no-body>
    <b-card-header class="border-0">
      <b-row>
        <b-col>
          <h3 class="mb-0">{{ title }}</h3>
        </b-col>

        <b-col xl="3" md="6">
          <b-form-group>
            <b-form-checkbox
              v-if="showCheckboxButton"
              v-model="mostrarNoAsignados"
              switch
              label="No asignados"
              @change="fetchData"
            >
              No asignados
            </b-form-checkbox>
          </b-form-group>
        </b-col>

        <b-col xl="3" md="6">
          <b-input-group class="input-group-alternative input-group-merge">
            <b-form-input
              placeholder="Buscar"
              type="text"
              v-model="localSearchQuery"
              @input="onSearch"
            ></b-form-input>
            <div class="input-group-append">
              <span class="input-group-text"
                ><i class="fas fa-search"></i
              ></span>
            </div>
          </b-input-group>
        </b-col>
      </b-row>
    </b-card-header>

    <el-table
      class="table-responsive table"
      header-row-class-name="thead-light"
      :data="data"
      :empty-text="'No hay datos disponibles'"
    >
      <!--Columnas de checkbox-->
      <el-table-column v-if="showCheckbox" width="120" label="Select">
        <template v-slot="{ row }">
          <base-checkbox
            :checked="selectedRows"
            :value="row.ICCID"
            @change="handleCheckboxChange"
          />
        </template>
      </el-table-column>

      <!-- Columnas dinámicas -->
      <el-table-column
        v-for="column in columns"
        :key="column.prop"
        :label="column.label"
        :prop="column.prop"
        :min-width="column.minWidth || '80px'"
      >
        <template v-slot="{ row }">
          <slot :name="`column-${column.prop}`" :row="row">
            {{ row[column.prop] }}
          </slot>
        </template>
      </el-table-column>

      <!-- Columna de acciones -->
      <el-table-column
        v-if="actions.length > 0"
        label="Acciones"
        min-width="120px"
      >
        <template v-slot="{ row }">
          <div class="d-flex gap-2 justify-content-center">
            <button
              v-for="action in actions"
              :key="action.name"
              class="btn btn-sm"
              :class="action.class || 'btn-outline-primary'"
              @click="action.onClick(row)"
            >
              <slot :name="`icon-${action.name}`">
                <i v-if="action.icon" :class="action.icon"></i>
              </slot>
              {{ action.label }}
            </button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- Paginación -->
    <b-card-footer
      v-if="total > perPage"
      class="py-4 d-flex justify-content-end"
    >
      <base-pagination
        v-model="currentPage"
        :page-count="pageCount"
        :per-page="perPage"
        :total="total"
        @change="onPageChange"
      />
    </b-card-footer>
  </b-card>
</template>

<script>
import ButtonCheckbox from "../../../components/ButtonCheckbox.vue";
import BaseCheckbox from "../../../components/Inputs/BaseCheckbox.vue";

export default {
  components: {
    BaseCheckbox,
    ButtonCheckbox,
  },
  name: "ReusableTable",
  props: {
    title: {
      type: String,
      default: "Tabla",
    },
    data: {
      type: Array,
      required: true,
      validator: (value) => Array.isArray(value),
    },
    columns: {
      type: Array,
      required: true,
      validator: (value) =>
        Array.isArray(value) && value.every((col) => col.prop && col.label),
    },
    actions: {
      type: Array,
      default: () => [],
      validator: (value) =>
        Array.isArray(value) &&
        value.every((action) => action.name && action.label && action.onClick),
    },
    perPage: {
      type: Number,
      default: 10,
      validator: (value) => value > 0,
    },
    pageCount: {
      type: Number,
      default: 1,
      validator: (value) => value > 0,
    },
    total: {
      type: Number,
      required: true,
      validator: (value) => value >= 0,
    },
    searchQuery: {
      type: String,
      default: "",
    },
    showCheckbox: {
      type: Boolean,
      default: false,
    },
    showCheckboxButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentPage: 1,
      localSearchQuery: this.searchQuery,
      mostrarNoAsignados: false, // Estado del switch
      selectedRows: [],
    };
  },
  watch: {
    currentPage() {
      this.fetchData();
    },
    searchQuery(newVal) {
      this.localSearchQuery = newVal;
    },
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.fetchData();
    },
    onSearch() {
      this.currentPage = 1;
      this.fetchData();
    },
    fetchData() {
      this.$emit("fetch-data", {
        page: this.currentPage,
        perPage: this.perPage,
        search: this.localSearchQuery,
        mostrarNoAsignados: this.mostrarNoAsignados,
      });
    },
    handleCheckboxChange(newValue) {
      this.selectedRows = newValue;
      this.$emit("checkbox-change", this.selectedRows);
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>